import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { CoreModule } from '../../core/core.module';
import { NotificationSwitchComponent } from './components/notification-switch/notification-switch.component';
import { NotificationsDialogComponent } from './components/notifications-dialog/notifications-dialog.component';
import { SupportComponent } from './components/support/support.component';
import { HubSubscriptionNamePipe } from './pipes/hub-subscription-name.pipe';

@NgModule({
  declarations: [
    NotificationsDialogComponent,
    NotificationSwitchComponent,
    HubSubscriptionNamePipe,
    SupportComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatSlideToggleModule,
    CoreModule,
    MatIconModule,
    DragDropModule
  ],
  exports: [
    MatSlideToggleModule,
    NotificationsDialogComponent,
    NotificationSwitchComponent,
    HubSubscriptionNamePipe,
    SupportComponent
  ]
})
export class AdminSharedModule { }
